import React, { useCallback, useEffect, useState } from 'react'
// Reusable Components -----------------------------------------------
import Overview from "../pages/Overview"
import TdsCalculation from "../pages/TdsCalculation"
import ProofsDocuments from "../pages/ProofsDocuments"
import AuditTrail from "../pages/AuditTrail"
import { getTdsDecListData, initDecList } from '../../../../redux/slices/tdsSlice'
import { getTDSDeclarationFormPath } from '../../../../services/config'
import { useDispatch } from 'react-redux'
import { useSelect } from '../../../../services/commonServices'

const Tabs = ({ staffId }) => {

    const [activeTdsTab, setActiveTdsTab] = useState(1)
    const handleTabClick = (id) => {
        setActiveTdsTab(id)
    }

    const user = JSON.parse(localStorage.getItem("user_data")) || {}

    const dispatch = useDispatch()
    const tdsStore = useSelect("tds")

    const [reviewTdsDeclaration, setReviewTdsDeclaration] = useState({})
    const [declaration, setDeclaration] = useState({})
    const [documentFieldsMetadata, setDocumentFieldsMetadata] = useState({})
    const [tdsCalculation, setTdsCalculation] = useState({})
    const [regimeType, setRegimeType] = useState("") 

    const getReviewTdsDeclaration = useCallback(() => {
        const formData = {
            path: getTDSDeclarationFormPath,
            data: {
                staffId: staffId
            }
        }
        dispatch(getTdsDecListData(formData))
    }, [])

    useEffect(() => {
        if (tdsStore.tdsDeclData === null) {
            getReviewTdsDeclaration()
        } else {
            setReviewTdsDeclaration(tdsStore.tdsDeclData ?? {})
            setTdsCalculation(tdsStore.tdsDeclData.tdsCalculation ?? {})
            setDeclaration(tdsStore.tdsDeclData.declaration ?? {})
            setDocumentFieldsMetadata(tdsStore.tdsDeclData.documentFieldsMetadata ?? {})
            setRegimeType(tdsStore.tdsDeclData?.tdsCalculation?.selectedRegime ?? "old")
        }
    }, [])

    useEffect(() => {
        //tds calculation------------
        if (tdsStore.tdsDeclSuccess) {
            setReviewTdsDeclaration(tdsStore.tdsDeclData)
            setTdsCalculation(tdsStore.tdsDeclData.tdsCalculation ?? {})
            setDeclaration(tdsStore.tdsDeclData.declaration ?? {})
            setDocumentFieldsMetadata(tdsStore.tdsDeclData.documentFieldsMetadata ?? {})
            setRegimeType(tdsStore.tdsDeclData?.tdsCalculation?.selectedRegime ?? "old")
            dispatch(initDecList())
        }
    }, [tdsStore])
// declaration, documentFieldsMetadata
    const tabs = [
        {
            id: 1, label: "Overview", icon: "", onclick: handleTabClick, component: <Overview
                declaration={declaration} documentFieldsMetadata={documentFieldsMetadata} tdsCalculation={tdsCalculation} regimeType={regimeType}
            />
        },
        {
            id: 2, label: "TDS Calculation", icon: "", onclick: handleTabClick, component: <TdsCalculation
                declaration={declaration} documentFieldsMetadata={documentFieldsMetadata} tdsCalculation={tdsCalculation} regimeType={regimeType}
            />
        },
        {
            id: 3, label: "Proofs & Documents", icon: "", onclick: handleTabClick, component: <ProofsDocuments
                declaration={declaration} documentFieldsMetadata={documentFieldsMetadata} tdsCalculation={tdsCalculation} regimeType={regimeType}
            />
        },
        {
            id: 4, label: "Audit Trail", icon: "", onclick: handleTabClick, component: <AuditTrail
                declaration={declaration} documentFieldsMetadata={documentFieldsMetadata} tdsCalculation={tdsCalculation} regimeType={regimeType}
            />
        },
    ]

    return (
        <div className='mb-5'>
            <div className='emp-tds-tabs mb-2 p-4'>
                {
                    tabs.map(item => {
                        return <button className={activeTdsTab === item.id ? `active` : ``} onClick={() => item.onclick(item.id)} key={item.id}> {item.icon} {item.label} </button>
                    })
                }
            </div>
            <div className='mb-5'>
                {
                    tabs.map(item => {
                        return activeTdsTab === item.id ? item.component : ``
                    })
                }
            </div>
            <br />
            <br />
        </div>
    )
}

export default Tabs